import React from "react";

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <p>&copy; RebLoza 2022</p>
        <p>-</p>
        <p>Dogy Events</p>
      </div>
    </footer>
  );
}

export default Footer;
